import { Helmet } from 'react-helmet-async';

interface SecurityHeadersProps {
  nonce?: string;
}

/**
 * Component that adds security headers to prevent XSS and other attacks
 */
export const SecurityHeaders = ({ nonce }: SecurityHeadersProps) => {
  return (
    <Helmet>
      <meta 
        httpEquiv="Content-Security-Policy" 
        content={`
          default-src 'self'; 
          script-src 'self' ${nonce ? `'nonce-${nonce}'` : "'unsafe-inline'"} 'unsafe-eval' https://apis.google.com https://www.googletagmanager.com https://pagead2.googlesyndication.com https://www.google.com https://googleads.g.doubleclick.net https://tpc.googlesyndication.com https://www.google-analytics.com; 
          script-src-elem 'self' ${nonce ? `'nonce-${nonce}'` : "'unsafe-inline'"} 'unsafe-eval' https://apis.google.com https://www.googletagmanager.com https://pagead2.googlesyndication.com https://www.google.com https://googleads.g.doubleclick.net https://tpc.googlesyndication.com https://www.google-analytics.com;
          style-src 'self' 'unsafe-inline' https://fonts.googleapis.com; 
          font-src 'self' https://fonts.gstatic.com; 
          img-src 'self' data: https: blob:; 
          connect-src 'self' https://*.supabase.co wss://*.supabase.co https://api.emailjs.com https://www.google-analytics.com https://analytics.google.com https://pagead2.googlesyndication.com https://ep1.adtrafficquality.google https://*.google.com https://region1.google-analytics.com https://googleads.g.doubleclick.net https://stats.g.doubleclick.net; 
          frame-src 'self' https://www.google.com https://www.googletagmanager.com https://googleads.g.doubleclick.net;
        `.replace(/\s+/g, ' ').trim()}
      />
      <meta httpEquiv="X-Content-Type-Options" content="nosniff" />
      {/* X-Frame-Options should be set via HTTP header, not meta tag */}
      <meta httpEquiv="X-XSS-Protection" content="1; mode=block" />
      <meta httpEquiv="Referrer-Policy" content="strict-origin-when-cross-origin" />
      <meta httpEquiv="Permissions-Policy" content="geolocation=(), microphone=(), camera=()" />
    </Helmet>
  );
};